document.addEventListener('DOMContentLoaded', function () {
    newsletterSignup();
});

// Newsletter singup form
function newsletterSignup() {
    let form = document.querySelector('#newsletter-form');
    let formHeader = document.querySelector('#newsletter-form-header');
    if (form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();

            let name = form.querySelector('input[name="name"]').value;
            let email = form.querySelector('input[name="email"]').value;

            if (formHeader) {
                let alert = formHeader.querySelector('.alert');
                if (alert) {
                    alert.parentNode.removeChild(alert);
                }
            }

            axios.post('ajax/mailchimp', {
                name: name,
                email: email
            })
            .then(function (response) {
                let feedback = response.data;
                let alertClass;
                if (feedback.hasOwnProperty('error') && feedback.error === 1) {
                    alertClass = 'danger';
                } else {
                    form.style.display = 'none';
                    alertClass = 'success';
                }
                formHeader.insertAdjacentHTML('beforeend', '<div class="alert mb-2 alert-' + alertClass + ' alert-dismissible fade show" role="alert">' + feedback.message + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
            })
            .catch(function (error) {
                console.log(error);
            });

        }, false);
    }

}
